import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { CodigosDeChamadaIntegracao } from './codigos-de-chamada-integracao.interface'

export class ConfiguracaoIntegracaoOperadora {
    operadora: OperadoraDeMaquina
    codigos: CodigosDeChamadaIntegracao

    constructor(operadora: OperadoraDeMaquina, codigos?: CodigosDeChamadaIntegracao) {
        this.operadora = operadora
        this.codigos = codigos

        if (!this.codigos) {
            this.codigos = {
                NomeDaOperadora: operadora.nome,
                Bandeira: '',
                VendaCredito: '',
                VendaDebito: '',
                RecebimentoLiquidoCredito: '',
                RecebimentoLiquidoDebito: '',
                TaxaOperadoraCredito: '',
                TaxaOperadoraDebito: '',
                EstornoDeVendasCredito: '',
                EstornoDeVendasDebito: '',
                Aluguel: '',
                OutrosAjustes: '',
                AntecipacaoTaxa: null
            }

            if (operadora.antecipa) {
                this.codigos.AntecipacaoTaxa = ''
            }
        }
    }
}

export interface ValorIntegracaoConciliadorWCONT {
    CodigosContabeis: CodigosDeChamadaIntegracao[]
}



// WEBPACK FOOTER //
// ./src/app/configuracao/shared/configuracao-integracao-operadora.ts